export const itemOrderStatusLabel = {
  draft: 'Unordered',
  received: 'Delivered',
  ordered: 'Ordered',
  cancelled: 'Canceled',
};

export const itemOrderStatusColor = {
  draft: '#dda157',
  received: '#629441',
  ordered: '#4facf2',
  cancelled: '#d47877',
  returned: '#916a39',
};

export const OrderStateType = Object.freeze({
  notFinalized: '',
  fullyPaid: 'Fully paid',
  accountsReceivable: 'Send to AR',
  thirdPartyAccounts: '3rd party',
});
